var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealTimeAnaysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00278 6.44575C4.00278 3.6857 6.24023 1.44824 9.00028 1.44824C11.7604 1.44824 13.9978 3.6857 13.9978 6.44575V9.00007C13.9978 9.28837 14.0913 9.56894 14.2644 9.79968L15.7969 11.8431C16.2911 12.5019 15.821 13.4422 14.9973 13.4422H3.00327C2.17964 13.4422 1.70948 12.5019 2.20367 11.8431L3.73624 9.79968C3.90925 9.56894 4.00278 9.28837 4.00278 9.00007V6.44575ZM13.2649 10.5493L14.4975 12.1929H3.50302L4.73574 10.5493C5.07095 10.1023 5.25216 9.55869 5.25216 9.00007V6.44575C5.25216 4.37572 6.93025 2.69762 9.00028 2.69762C11.0703 2.69762 12.7484 4.37572 12.7484 6.44575V9.00007C12.7484 9.55869 12.9296 10.1023 13.2649 10.5493Z",
    fill: "#47423D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00062 17.3157C7.63587 17.3157 6.51449 16.2737 6.38867 14.9419H7.64896C7.76647 15.5817 8.32694 16.0663 9.00062 16.0663C9.67434 16.0663 10.2348 15.5817 10.3522 14.9419H11.6126C11.4868 16.2737 10.3654 17.3157 9.00062 17.3157Z",
    fill: "#47423D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0026 2.32287C3.11052 3.51231 2.62829 4.959 2.62829 6.44581V7.44531H1.37891V6.44581C1.37891 4.68868 1.94882 2.97895 3.0031 1.57324L4.0026 2.32287Z",
    fill: "#47423D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3724 6.44581C15.3724 4.959 14.8901 3.51231 13.998 2.32287L14.9975 1.57324C16.0518 2.97895 16.6218 4.68868 16.6218 6.44581V7.44531H15.3724V6.44581Z",
    fill: "#47423D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeAnaysis);
export default __webpack_public_path__ + "static/media/real-time-anaysis.233e75dfd23e20a48e0ef0a400dad13a.svg";
export { ForwardRef as ReactComponent };